module.exports = __webpack_public_path__ + "static/media/fly0287.ce6b9248.webp";